import { PosProps, PosStatuses, PosErrorStatusCodes } from '@/interfaces/models/pos';

const NON_TITAN_A_DEVIDCES = [
  'webkassa',
  'alfa-proxy',
  'alfa',
  'ecrs',
  'ikassa',
  '4ek',
]

export default class Pos {
  public status: PosStatuses;
  public statusCode: number;
  public text: string;
  public physicalCash: number;
  public testCash: number;
  public cardCash: number;
  public posType: string;

  constructor(posProps: PosProps = Pos.getDefaultPosProps()) {
    this.status = posProps.status;
    this.statusCode = posProps.statusCode;
    this.physicalCash = posProps.physicalCash;
    this.testCash = posProps.testCash;
    this.cardCash = posProps.cardCash;
    this.posType = posProps.posType;
    this.text = Pos.getStatsTextByStatusAndStatusCode(posProps.status, posProps.statusCode, posProps.posType);
  }

  public static getDefaultPosProps() {
    return {
      status: 3,
      statusCode: 0,
      physicalCash: 0,
      testCash: 0,
      cardCash: 0,
      posType: 'alfa'
    };
  }

  public static getStatsTextByStatusAndStatusCode(status: number, statusCode: number, posType: string): string {
    if (status === PosStatuses.SUCCESS) {
      return 'Всё хорошо';
    }

    if (status === PosStatuses.WARNING) {
      if (posType === 'titanA') {
        return 'Нет денег в кассе';
      }

      return 'Смена не открыта';
    }

    if (status === PosStatuses.ERROR) {
      return Pos.getErrorTextByStatusCode(statusCode);
    }

    return 'Устройство не обнаружено';
  }

  public static getErrorTextByStatusCode(statusCode: number) {
    switch (statusCode) {
      case PosErrorStatusCodes.NO_PAPER: {
        return 'Нет бумаги';
      }

      case PosErrorStatusCodes.PROGRAMMING_MODE_IS_NOT_ENABLED: {
        return 'Выключен режим программирования';
      }

      default: {
        return 'Ошибка в кассе';
      }
    }
  }

  get isNonTitanA() {
    return NON_TITAN_A_DEVIDCES.includes(this.posType);
  }

  get isShiftClosed() {
    if (this.isNonTitanA) {
      return this.status === PosStatuses.WARNING;
    }

    return false;
  }

  get isHaveError() {
    return this.status === PosStatuses.UNDEFINED || this.status === PosStatuses.ERROR;
  }

  get haveNoManyInPos() {
    return this.physicalCash === 0;
  }

  get cashInPos() {
    return this.testCash + this.physicalCash + this.cardCash;
  }

  get cashInPosWithoutTestCash() {
    return this.physicalCash + this.cardCash;
  }

  get isErrorStatus() {
    return this.status === PosStatuses.ERROR;
  }

  get isUndefinedStatus() {
    return this.status === PosStatuses.UNDEFINED;
  }

  get isSuccessStatus() {
    return this.status === PosStatuses.SUCCESS;
  }

  get isWarningStatus() {
    return this.status === PosStatuses.WARNING;
  }

  get errorByStatusCode() {
    if (this.isErrorStatus) {
      return new Error(String(this.statusCode));
    }

    if (this.isShiftClosed) {
      return new Error('Смена не открыта');
    }

    if (this.isUndefinedStatus) {
      return new Error('-1');
    }

    return new Error('Undefined error');
  }
}
